// import 'es6-promise/auto';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import lilliPlugin from './plugin/lilli_plugin';

Vue.config.productionTip = false;

Vue.use(lilliPlugin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
